<edit-dialog (action)="signalAction($event)" [title]="title" class="flex flex-col">
  <ng-container edit-body class="text-black">
    <div id="_modal-CENTER" class="w-full flex justify-start modal-center">
      <div class="p-2 flex flex-col">
        <div class="py-1 border-black border-b-2">
          {{ baseFleet.fleetName }}
        </div>
        <table>
          @for (ship of baseFleet.ships; track ship._id) {
            <tr>
              <td>{{ ship.shipName }}</td>
              <td>{{ ship.hullClass }}</td>
            </tr>
          }
        </table>
      </div>
      <div class="p-2 flex flex-col">
        @for (fleet of otherFleets; track fleet._id) {
          <div class="flex flex-col">
            <div class="py-1 border-black border-b-2">
              <input type="checkbox" [checked]="selectedFleets.has(fleet._id)" (change)="toggleFleet(fleet._id)" />
              {{ fleet.fleetName }}
            </div>
            <table>
              @for (ship of fleet.ships; track ship._id) {
                <tr>
                  <td>{{ ship.shipName }}</td>
                  <td>{{ ship.hullClass }}</td>
                </tr>
              }
            </table>
          </div>
        }
      </div>
    </div>
  </ng-container>
</edit-dialog>
